module.exports = __webpack_public_path__ + "img/hr-inserter-platform.5865aff7.png";